import env from 'VirtualEnv'

export const domain = env.AUTH0_DOMAIN || 'ee-dev.eu.auth0.com'
export const clientId = env.AUTH0_CLIENT_ID || 'MDU7ykJ0LBclcax8gJ0pfh3r3c11lOlb'
export const audience = 'yoda-bridge-gateway'
